import { render, staticRenderFns } from "./NewFlowModal.vue?vue&type=template&id=63d08e2c"
import script from "./NewFlowModal.vue?vue&type=script&lang=js"
export * from "./NewFlowModal.vue?vue&type=script&lang=js"
import style0 from "./NewFlowModal.vue?vue&type=style&index=0&id=63d08e2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports